import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { InlineSVGModule } from 'ng-inline-svg';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';

import { SharedModule } from 'src/app/shared/shared.module';
import { ResetPasswordComponent } from './reset-password.component';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';

@NgModule({
  declarations: [ResetPasswordComponent, ResetPasswordFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule,
    NzButtonModule,
    NzCardModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
  ],
})
export class ResetPasswordModule {}
